import { deepFreeze } from '@/common/functions/deepFreeze';

export const emailSubjects = deepFreeze([
	{ value: 'document', label: 'HR - certificate/documents' },
	{ value: 'refund', label: 'HR - refund for shipping cost' },
	{ value: 'paycheck', label: 'HR - paycheck ' },
	{ value: 'others', label: 'HR - others' },
	{ value: 'cc', label: 'CC' },
]);
